import { useState, useEffect } from 'react';
import FormAgentCard from '@IssueConsoleRepresentationalDisplay/FormAgentCard';
import FormAgentForm from '@IssueConsoleForms/FormAgentForm';
import ErrorHandler from '@Root/ErrorHandler';
import Skeleton from '@mui/material/Skeleton';
import FormAgentService from '@Helpers/URLHelpers/KaiziqResolve/FormAgentService';
import { MdPeople as People, MdPersonAdd as PersonAdd } from 'react-icons/md';
import { useReduxOrg } from '@Hooks/reduxOrgHook/useReduxOrg';
import { useReduxActiveUser } from '@Hooks/reduxActiveUserHook/useReduxActiveUser';
import { useReduxProject } from '@Hooks/reduxProjectHook/useReduxProject';
import '@Partials/_SimpleStyles.scss';
import '@Partials/_ComStyles.scss';
import './AgentsPage.scss';

export default function AgentsPage(props) {

    const [kaiziqResolveConnection, setKaiziqResolveConnection] = useState({});
    const [formAgentList, setFormAgentList] = useState([]);
    const [showFormAgentForm, setShowFormAgentForm] = useState(false);
    const [, setInternetException] = useState(false);
    const [seatDetails] = useState({});
    const [cursor, setCursor] = useState('auto');
    const [pageLoader, setPageLoader] = useState(true);
    useReduxActiveUser();
    useReduxOrg();
    useReduxProject();
    let formAgentService = new FormAgentService()
    const errorHandler = new ErrorHandler();
    const className = 'resolve__agentsPage';

    useEffect(() => {
        setKaiziqResolveConnection(props.kaiziqResolveConnection);
        renderData();
    }, [props])

    const renderData = async() => {
        setPageLoader(true);
        setCursor('wait');
        await renderFormAgentList();
        setCursor('auto');
        setPageLoader(false);
    }

    const renderFormAgentList = async() => {
        var loadLoops = 0, loadingError = false, errorException;
        for(loadLoops = 0; loadLoops < 10; loadLoops++) {
            try {
                let formAgentListObj = await formAgentService.getListByForm(props.kaiziqResolveConnection?.id);
                formAgentListObj = JSON.parse(formAgentListObj.body)
                setFormAgentList(formAgentListObj);
                loadingError = false;
                break;
            } catch (err) {
                errorHandler.logError('Form Agent List Data', err);
                loadingError = true;
                errorException = err;
            }
        }
        if(loadLoops === 10 && loadingError === true) {
            errorHandler.handleError(errorException);
            setInternetException(true);
            return false;
        }
        return true;
    }

    const toggleShowFormAgentForm = () => {
        setShowFormAgentForm(!showFormAgentForm);
    }

    return (
        <div className={className} style={{cursor: cursor}}>
            {pageLoader ? (
                <div className={`${className}__loader`}>
                    <Skeleton variant="rectangular" width="100%" height={100} sx={{ borderRadius: '12px', marginBottom: '1.5rem' }} />
                    <div className={`${className}__loader__grid`}>
                        {[...Array(6)].map((_, i) => (
                            <Skeleton key={i} variant="rectangular" width="100%" height={120} sx={{ borderRadius: '12px' }} />
                        ))}
                    </div>
                </div>
            ) : (
                <div className={`${className}__container`}>
                    {/* Header */}
                    <div className={`${className}__header`}>
                        <div className={`${className}__header__left`}>
                            <People className={`${className}__header__icon`} />
                            <div className={`${className}__header__info`}>
                                <h1 className={`${className}__header__title`}>Form Agents</h1>
                                <p className={`${className}__header__subtitle`}>
                                    Manage users who can handle and respond to form submissions
                                </p>
                            </div>
                        </div>
                        <div className={`${className}__header__right`}>
                            <div className={`${className}__header__stats`}>
                                <div className={`${className}__header__stats__item`}>
                                    <span className={`${className}__header__stats__label`}>Total Agents</span>
                                    <span className={`${className}__header__stats__value`}>{formAgentList.length}</span>
                                </div>
                            </div>
                            <button className={`${className}__header__addBtn`} onClick={toggleShowFormAgentForm}>
                                <PersonAdd />
                                Add Agent
                            </button>
                        </div>
                    </div>

                    {/* Content */}
                    <div className={`${className}__content`}>
                        {formAgentList.length === 0 ? (
                            <div className={`${className}__empty`}>
                                <People className={`${className}__empty__icon`} />
                                <h3 className={`${className}__empty__title`}>No Agents Yet</h3>
                                <p className={`${className}__empty__desc`}>
                                    Add agents to help manage and respond to form submissions.
                                </p>
                                <button className={`${className}__empty__btn`} onClick={toggleShowFormAgentForm}>
                                    <PersonAdd />
                                    Add Your First Agent
                                </button>
                            </div>
                        ) : (
                            <div className={`${className}__grid`}>
                                {formAgentList.map((formAgent, index) => (
                                    <FormAgentCard
                                        key={index}
                                        formAgent={formAgent}
                                        kaiziqResolveConnection={kaiziqResolveConnection}
                                        reloadData={renderData}
                                    />
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            )}

            {showFormAgentForm && (
                <FormAgentForm
                    open={showFormAgentForm}
                    closePopup={toggleShowFormAgentForm}
                    kaiziqResolveConnection={kaiziqResolveConnection}
                    reloadData={renderData}
                    seatDetails={seatDetails}
                />
            )}
        </div>
    );
}

